import { Cart, CartItem, CartOrderDetailsIndex } from '@/models/cart';
import { Company } from '@/models/company';

import { CartState } from './state';

export function SET_CART(state: CartState, value: Cart) {
  state.cartId = value.cartId;
  state.orders = value.orders;
  state.validationErrors = value.validationErrors;
}

export function SET_ORDERS(state: CartState, placedOrders) {
  state.placedOrders = placedOrders;
}

export function REMOVE_ORDER(state: CartState, orderId: string) {
  state.validationErrors = [];
  state.orders = state.orders.filter((order) => order.id !== orderId);
}

export function UPDATE_MINI_CART_ITEM(state: CartState, payload: { index: number; item: CartItem }) {
  const { item, index } = payload;

  Object.keys(item).map((key) => {
    state.items[index][key] = item[key];
  });
}

export function UPDATE_ITEM(state: CartState, item: CartItem) {
  const order = state.orders.find((cartOrder) => cartOrder.id === item.orderId);

  if (order) {
    const targetItem = order.items.find((orderItem) => orderItem.id === item.id);

    if (targetItem) {
      Object.keys(item).map((key) => {
        targetItem[key] = item[key];
      });
    }
  }
}

export function SET_ORDER_DETAILS(state: CartState, payload: CartOrderDetailsIndex) {
  state.orderDetails = payload;
}

export function REMOVE_ORDER_DETAILS(state: CartState, orderId: string) {
  delete state.orderDetails[orderId];
}

export function SET_COMPANIES(state: CartState, value: Company[]) {
  state.companies = value;
}

export function SET_IS_LOADING(state: CartState, value: boolean) {
  state.isLoading = value;
}

export function SET_IS_LOADED(state: CartState, value: boolean) {
  state.isLoaded = value;
}

export function HAS_PAYMENT_ON_SELL_THROUGH_ERROR(state: CartState, value: boolean) {
  state.hasPaymentOnSellThroughError = value;
}

export function SET_CART_COUNT_OVERRIDE(state: CartState, value: number | null) {
  state.cartCountOverride = value;
}

export function SET_CART_COUNT(state: CartState, payload: { count: number }) {
  state.cartItemCount = payload.count;
}

export function SET_IS_UPDATING_CART(state: CartState, value: boolean) {
  state.isUpdatingCart = value;
}
